import {
  type QueryClient,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface ClassEventCountSessionById {
  classes: number;
  events: number;
}

export const getClassEventCountSessionByIdAPI = async (sessionId: string) => {
  const response = await baseAPI.get<ClassEventCountSessionById>(
    `/session/count/${sessionId}`,
  );
  return response.data;
};

export const sessionLinkedCountQueryKey = (sessionId?: string) =>
  sessionId
    ? ([KEYS.SESSIONS, KEYS.SESSION_LINKED_COUNT, sessionId] as const)
    : ([KEYS.SESSIONS, KEYS.SESSION_LINKED_COUNT] as const);

export const invalidateSessionLinkedCounts = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({
    queryKey: sessionLinkedCountQueryKey(),
  });

export const getClassEventCountSessionByIdOptions = (sessionId: string) => {
  return queryOptions({
    queryKey: sessionLinkedCountQueryKey(sessionId),
    queryFn: () => getClassEventCountSessionByIdAPI(sessionId),
    staleTime: 0,
  });
};

export const useGetClassEventCountSessionById = (sessionId: string) => {
  return useQuery(getClassEventCountSessionByIdOptions(sessionId));
};
